/**
 * Password form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React from 'react';
import { Field } from 'redux-form';
import FormGroup from 'Components/FormGroup';

import { CustomFormInput } from 'Common/Form';
import { confirmPasswordValidation, isPasswordStrongValidation, minLengthValidation, maxLengthValidation } from 'Utils';

const minLength6 = minLengthValidation(6);
const maxLength20 = maxLengthValidation(20);

export default function PasswordForm(props) {
    return (
        <FormGroup title="form_groups.password" {...props}>
            <Field
                rowClassName="mm-form-field"
                name="password"
                component={CustomFormInput}
                type="password"
                label="password"
                placeholder="password"
                validate={[minLength6, isPasswordStrongValidation, maxLength20]}
            />
            <Field
                rowClassName="mm-form-field"
                name="password_confirmation"
                component={CustomFormInput}
                type="password"
                label="confirm_password"
                placeholder="confirm_password"
                validate={[confirmPasswordValidation]}
            />
        </FormGroup>
    );
}



// WEBPACK FOOTER //
// ./src/components/FormGroup/PasswordForm.jsx